import { GoogleMap, Marker, withGoogleMap, withScriptjs, InfoWindow } from "react-google-maps";
import React, { useCallback, useMemo, useRef } from "react";
import PinGvg from "../../../../assets/icons/pin.svg";
import { useMapContext } from "./map.context";

const Common = withScriptjs(withGoogleMap(({ coordinate, onChange, children, ...props }) => {
  const { ref } = useMapContext();
  const onRef = useCallback(map => {
    ref.map = map;
  }, []);

  const onMapChange = useCallback(() => {
    if (ref.$timeout) {
      clearTimeout(ref.$timeout);
    }
    ref.$timeout = setTimeout(() => {
      const { lat, lng } = ref.map.getCenter()
      const coordinate = {
        latitude: lat(),
        longitude: lng(),
      }
      onChange && onChange(coordinate);
    }, 100)
  }, [ref, onChange])

  return (
    <GoogleMap
      defaultZoom={17}
      // defaultCenter={{ lat: coordinate.latitude, lng: coordinate.longitude }}
      options={{
        // disableDefaultUI: true,
        streetViewControl: false
      }}
      onCenterChanged={onChange ? onMapChange : null}
      ref={onRef}
      {...props}
    >
      {children}
    </GoogleMap>
  )
}));

export default function Map({ onChange, height = '200px', ...props }) {
  return (
    <ErrorBoundary>
      <Common
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBxis6cYt7v42uRpAfzHRROuRtb7-81Mok&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }}/>}
        containerElement={<div style={{ height }}/>}
        mapElement={<div style={{ height: `100%` }}/>}
        onChange={onChange}
        {...props}
      />
    </ErrorBoundary>
  )
}


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div>
          <h2>Something went wrong. Google maps is not available now.</h2>
          {/*<details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br/>
            {this.state.errorInfo.componentStack}
          </details>*/}
        </div>
      );
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Places/components/Address/Map.js